var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 546.69 73.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#231f20;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:url(#linear-gradient);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{clip-path:url(#clip-path-3);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{clip-path:url(#clip-path-4);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{clip-path:url(#clip-path-5);}.cls-13{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.22,62.59a3.94,3.94,0,1,0,3.94-3.94h0a3.93,3.93,0,0,0-3.93,3.93h0M30.16,15.35a3.94,3.94,0,1,0,3.95-3.93h0a3.93,3.93,0,0,0-3.94,3.92h0M62,39a3.94,3.94,0,1,1,3.94,3.94h0A4,4,0,0,1,62,39m9.29-27.55H54.72c-5.2,0-5.2,7.87,0,7.87h1.13c5.21,0,5.21,7.87,0,7.87H41.13c-5.21,0-5.22,7.87,0,7.87h8.29c5.21,0,5.21,7.88,0,7.88h-21c-5.2,0-5.21,7.87,0,7.87h10c5.2,0,5.19,7.87,0,7.87H35.33c-5.2,0-5.21,7.87,0,7.87H54c5.2,0,5.2,7.87,0,7.87H46.67c-5.2,0-5.2,7.87,0,7.87h55.41V73.13H104V67.24h-1.9V57.56H104V51.7h-1.9V42H104V36.12h-1.9V26.41H104V20.55h-1.9V11.42Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -7918.93,
    y1: -451.72,
    x2: -7917.93,
    y2: -451.72,
    gradientTransform: "translate(37964.52 -664448.13) rotate(-90) scale(83.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#650eba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.28,74.39c-5.21,0-5.21,7.87,0,7.87h7.33c5.21,0,5.2-7.87,0-7.87Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -7431.73,
    y1: -550.21,
    x2: -7430.73,
    y2: -550.21,
    gradientTransform: "translate(112538.79 8399.52) scale(15.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f05a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb008b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.21,42.91c-5.2,0-5.21,7.87,0,7.87h7.33c5.21,0,5.21-7.87,0-7.87Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -7431.74,
    y1: -550.22,
    x2: -7430.74,
    y2: -550.22,
    gradientTransform: "translate(112523.35 8368.24) scale(15.14)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.37,31.1a3.94,3.94,0,1,0,3.94-3.94,3.93,3.93,0,0,0-3.94,3.94v0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -6980.19,
    y1: -559.83,
    x2: -6979.19,
    y2: -559.83,
    gradientTransform: "translate(54971.63 4427.97) scale(7.87)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.83,11.42v9.13H104v5.86h1.88v9.71H104V42h1.88V51.7H104v5.86h1.88v9.68H104V73.1h1.88v9.14h30.5V58.65a11.81,11.81,0,0,1,0-23.62V11.42Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -7692.12,
    y1: -544.85,
    x2: -7691.12,
    y2: -544.85,
    gradientTransform: "translate(249196.94 17679.98) scale(32.38)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.45,80.79H201.61L174.69,36.62V80.79H160.85V13.66h13.84l27,44.26V13.66h13.79Z",
    transform: "translate(0 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.29,80.79V40.68h-7.42V30.9h7.42V26.66q0-8.4,4.82-13T248.6,9a31.52,31.52,0,0,1,6.78.92l-.14,10.33a16.83,16.83,0,0,0-4.06-.42q-7.52,0-7.52,7.06v4h9.92v9.78h-9.92V80.79Z",
    transform: "translate(0 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M276.45,18.64V30.9H285v9.78h-8.53V65.57a5.93,5.93,0,0,0,1.06,4c.7.8,2.06,1.2,4.06,1.2a21.8,21.8,0,0,0,3.92-.32V80.51a27.48,27.48,0,0,1-8.07,1.2q-14,0-14.3-14.15V40.68h-7.28V30.9h7.28V18.64Z",
    transform: "translate(0 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.31,18a6.54,6.54,0,0,1,2-4.93,8.63,8.63,0,0,1,10.9,0,6.52,6.52,0,0,1,2,4.93,6.57,6.57,0,0,1-2.05,5,8.54,8.54,0,0,1-10.84,0A6.53,6.53,0,0,1,292.31,18Zm14.15,62.8H293.09V30.9h13.37Z",
    transform: "translate(0 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338.19,71a8.75,8.75,0,0,0,6-2,7.09,7.09,0,0,0,2.4-5.39h12.49a17.13,17.13,0,0,1-2.76,9.29,18.3,18.3,0,0,1-7.45,6.54,23.19,23.19,0,0,1-10.44,2.33q-10.69,0-16.88-6.8t-6.18-18.79v-.87q0-11.53,6.14-18.4T338.33,30q9.36,0,15,5.32t5.74,14.18H346.58a9.13,9.13,0,0,0-2.4-6.32,8.9,8.9,0,0,0-13.12,1q-2.37,3.39-2.37,11v1.38q0,7.73,2.35,11.09T338.19,71Z",
    transform: "translate(0 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.8,60.78,380,65.57V80.79H366.68V10H380V49.21l2.58-3.32,12.77-15h16l-18,20.8,19.6,29.09H397.62Z",
    transform: "translate(0 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M433.08,18.64V30.9h8.53v9.78h-8.53V65.57a5.93,5.93,0,0,0,1.06,4c.71.8,2.06,1.2,4.06,1.2a21.8,21.8,0,0,0,3.92-.32V80.51a27.48,27.48,0,0,1-8.07,1.2q-14,0-14.3-14.15V40.68h-7.28V30.9h7.28V18.64Z",
    transform: "translate(0 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M449.72,74.24a6.7,6.7,0,0,1,2.15-5.16,8.34,8.34,0,0,1,10.79,0,7.24,7.24,0,0,1,0,10.26,8.47,8.47,0,0,1-10.84,0A6.65,6.65,0,0,1,449.72,74.24Z",
    transform: "translate(0 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M476.37,18a6.54,6.54,0,0,1,2-4.93,8.64,8.64,0,0,1,10.91,0,6.51,6.51,0,0,1,2,4.93,6.53,6.53,0,0,1-2.05,5,8.53,8.53,0,0,1-10.83,0A6.54,6.54,0,0,1,476.37,18Zm14.16,62.8H477.16V30.9h13.37Z",
    transform: "translate(0 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.43,55.38a29.54,29.54,0,0,1,2.86-13.23,20.91,20.91,0,0,1,8.23-9A24,24,0,0,1,523,30q10.1,0,16.48,6.18t7.13,16.78l.09,3.41q0,11.49-6.41,18.42t-17.2,6.94q-10.79,0-17.22-6.91T499.43,56Zm13.32.95q0,7.11,2.68,10.88a9.6,9.6,0,0,0,15.21,0q2.73-3.72,2.72-11.89,0-7-2.72-10.81A8.84,8.84,0,0,0,523,40.72a8.69,8.69,0,0,0-7.56,3.81Q512.76,48.34,512.75,56.33Z",
    transform: "translate(0 -9)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.21,
    y: 2.42,
    width: 95.74,
    height: 70.85
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 17.07,
    y: 65.39,
    width: 17.75,
    height: 7.87
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    y: 33.91,
    width: 17.75,
    height: 7.87
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 23.37,
    y: 18.16,
    width: 7.87,
    height: 7.87
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 103.95,
    y: 2.42,
    width: 32.38,
    height: 70.85
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2ab3da6b75352092f21584387990d359.svg";
export { ForwardRef as ReactComponent };